<div class="crypto-card" [class.bundle]="isBundle">
  <div class="card-header">
    <div *ngIf="!isBundle" class="coin-container">
      <img [src]="'/assets/icons/crypto/' + cryptoSymbol.toLowerCase() + '.svg'" alt="" />
      <p class="coin-label">{{ cryptoSymbol.replace('UST', 'USTC') }}</p>
      <p
        class="variance"
        [class.grow]="variation > 0"
        [class.drop]="variation < 0"
        *ngIf="variation < 0 || variation === 0 || variation > 0"
      >
        {{ variation > 0 ? '+' : '' }}{{ variation | number : '0.2-2' }}%
      </p>
    </div>
    <div *ngIf="isBundle" class="coin-container">
      <img [src]="'/assets/icons/crypto/bundles/' + bundle.ticker + '.svg'" alt="" />
      <p class="card-type">Canasta</p>
      <p class="bundle-label">{{ bundle.name }}</p>
    </div>
    <div class="bundle-variation" *ngIf="isBundle">
      <p [class.up]="bundleVariation > 0" [class.down]="bundleVariation < 0">
        {{ bundleVariation | number : '0.2-2' }}%
      </p>
    </div>
    <div *ngIf="!isBundle" class="crypto-price">
      <p *ngIf="isArsCurrency" class="price-outside">Compra</p>
      <p *ngIf="isArsCurrency" class="price">
        {{ crypto.active && prices ? (prices.buy || 0 | currency : '$') : '-' }}
      </p>
      <p *ngIf="isArsCurrency" class="price-outside">Venta</p>
      <p *ngIf="isArsCurrency" class="price">
        {{ crypto.active && prices ? (prices.sell || 0 | currency : '$') : '-' }}
      </p>
      <p *ngIf="!isArsCurrency" class="price-outside">Compra</p>
      <p *ngIf="!isArsCurrency" class="price">
        {{
          crypto.active && prices ? (prices.buy || 0 | currency : '$' : 'symbol' : '0.3-3') : '-'
        }}
      </p>
      <p *ngIf="!isArsCurrency" class="price-outside">Venta</p>
      <p *ngIf="!isArsCurrency" class="price">
        {{
          crypto.active && prices ? (prices.sell || 0 | currency : '$' : 'symbol' : '0.3-3') : '-'
        }}
      </p>
    </div>
  </div>
  <img
    *ngIf="!isBundle"
    class="card-background"
    [src]="'/assets/icons/crypto/backgrounds/' + cryptoSymbol.toLowerCase() + '.svg'"
    (error)="img.src = '/assets/icons/crypto/' + cryptoSymbol.toLowerCase() + '.svg'"
    #img
  />
  <img
    *ngIf="isBundle"
    class="card-background bundle"
    [src]="'/assets/icons/crypto/bundles/' + bundle.ticker + '_background.svg'"
  />
  <div *ngIf="!isBundle">
    <div class="overlay" [class.show]="!crypto.active"></div>
    <p class="disabled-label" [class.show]="!crypto.active">Proximamente</p>
    <div class="tags-section">
      <div
        *ngFor="let tag of coinBasicInfo?.tags"
        class="tag"
        [class.stable]="tag === 'Estable'"
        [class.volatil]="tag === 'Volátil'"
        [class.hot]="tag === 'Hot'"
      >
        <p>{{ tag }}</p>
      </div>
    </div>
  </div>
  <div *ngIf="isBundle" class="coins-section">
    <img
      *ngFor="let coin of bundle.coins"
      [src]="'/assets/icons/crypto/' + coin.ticker.toLowerCase() + '.svg'"
    />
  </div>
</div>
